import React from "react";
import { PROMO } from "@/lib/data";
import { Sparkles, ArrowRight, X } from "lucide-react";

const STORAGE_KEY = "dt_promo_dismissed";

export const PromoBar = ({ onClaim }) => {
  const [visible, setVisible] = React.useState(true);

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (dismissed === "1") setVisible(false);
  }, []);

  if (!PROMO.enabled || !visible) return null;

  const dismiss = (e) => {
    e.stopPropagation();
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  return (
    <div
      data-testid="promo-bar"
      className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-[#3B0066] via-[#4B0082] to-[#3B0066] text-white shadow-md"
    >
      <button
        type="button"
        onClick={onClaim}
        data-testid="promo-bar-claim"
        className="group w-full flex items-center justify-center gap-3 px-6 py-2.5 sm:py-3 cursor-pointer hover:bg-white/5 transition-colors"
      >
        <span className="hidden sm:inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#C4A6F0]/20 ring-1 ring-[#C4A6F0]/40">
          <Sparkles className="w-3.5 h-3.5 text-[#F0E0FF]" />
        </span>
        <span className="text-sm sm:text-base font-semibold tracking-tight text-center">
          <span className="hidden sm:inline">{PROMO.text}</span>
          <span className="sm:hidden">Full Detail $150 — first 25 customers</span>
        </span>
        <span className="hidden md:inline-flex items-center px-2 py-0.5 rounded-full bg-[#FFD600] text-[#3B0066] text-[10px] font-bold uppercase tracking-widest">
          {PROMO.badge}
        </span>
        <span className="inline-flex items-center gap-1 text-sm font-semibold underline decoration-2 underline-offset-4 decoration-[#C4A6F0] group-hover:decoration-white">
          Claim
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
        </span>
      </button>
      <button
        onClick={dismiss}
        data-testid="promo-bar-dismiss"
        aria-label="Dismiss promo"
        className="absolute top-1/2 -translate-y-1/2 right-2 sm:right-4 w-7 h-7 flex items-center justify-center rounded-full text-white/70 hover:text-white hover:bg-white/10"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
